var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlinePlayAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.25 12C1.25 6.07 6.07 1.25 12 1.25S22.75 6.07 22.75 12c0 1.4-.26 2.74-.78 4-.09.21-.26.37-.48.43a.73.73 0 0 1-.64-.1 3.303 3.303 0 0 0-3.89.13 3.224 3.224 0 0 0-.75 4.2c.03.05.05.08.08.11.16.18.22.43.17.67-.05.24-.22.43-.45.52-1.27.53-2.62.79-4.01.79-5.93 0-10.75-4.82-10.75-10.75zm1.5 0c0 5.1 4.15 9.25 9.25 9.25.9 0 1.78-.13 2.63-.39-.25-.58-.38-1.21-.38-1.86 0-1.46.65-2.81 1.78-3.71 1.36-1.08 3.27-1.33 4.83-.66.25-.84.38-1.73.38-2.64.01-5.09-4.14-9.24-9.24-9.24-5.1 0-9.25 4.15-9.25 9.25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.799 15.79c-.74-.43-1.17-1.3-1.17-2.4v-2.78c0-1.1.43-1.97 1.17-2.4.75-.43 1.72-.36 2.67.19l2.4 1.39c.95.55 1.49 1.36 1.49 2.21 0 .85-.54 1.67-1.49 2.21l-2.4 1.39c-.54.31-1.08.47-1.59.47-.39 0-.76-.09-1.08-.28zm.75-6.28c-.27.16-.42.56-.42 1.1v2.78c0 .54.15.95.42 1.1.27.15.69.09 1.17-.19l2.4-1.39c.47-.27.74-.61.74-.92 0-.31-.27-.64-.74-.92l-2.4-1.39c-.31-.16-.59-.25-.83-.25-.13 0-.24.03-.34.08zM14.94 21.44c-.45-.72-.69-1.57-.69-2.44 0-1.46.65-2.81 1.78-3.71.84-.67 1.9-1.04 2.97-1.04 2.62 0 4.75 2.13 4.75 4.75 0 .87-.24 1.72-.69 2.45-.25.42-.57.8-.95 1.12-.83.76-1.94 1.18-3.11 1.18-1.66 0-3.22-.88-4.06-2.31zm2.03-4.97a3.224 3.224 0 0 0-.75 4.2c.58.98 1.65 1.58 2.78 1.58.79 0 1.55-.29 2.13-.81.26-.22.48-.48.64-.76.32-.51.48-1.09.48-1.68 0-1.79-1.46-3.25-3.25-3.25-.74 0-1.44.25-2.03.72z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.51 19.73c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h2.99c.41 0 .75.34.75.75s-.34.75-.75.75h-2.99z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.25 20.51v-2.99c0-.41.34-.75.75-.75s.75.34.75.75v2.99a.749.749 0 1 1-1.5 0z",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlinePlayAdd);
export default __webpack_public_path__ + "static/media/vuesax-outline-play-add.295883c796c5d9548c0e7151c99773da.svg";
export { ForwardRef as ReactComponent };